var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStorefront = function SvgStorefront(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.592 5.016v5.558a1.093 1.093 0 0 0 1.093 1.093H9.98a1.09 1.09 0 0 0 1.092-1.093V5.016a.5.5 0 0 0-1 0v5.558q0 .039-.027.066a.1.1 0 0 1-.065.027H1.685a.09.09 0 0 1-.093-.093V5.016a.5.5 0 0 0-1 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.167 5.165.036.038a1.833 1.833 0 0 0 2.63-.038l.037.038a1.833 1.833 0 0 0 2.593 0l.036-.038.038.038a1.833 1.833 0 0 0 3.13-1.296V2.86q0-.122-.058-.23L10.605.704q0-.004-.003-.007A1.32 1.32 0 0 0 9.427 0h-7.19a1.33 1.33 0 0 0-1.173.697L.057 2.63a.5.5 0 0 0-.057.23v1.048a1.834 1.834 0 0 0 3.167 1.258zM9.72 1.171l.945 1.811v.925a.833.833 0 0 1-1.422.59.84.84 0 0 1-.245-.59H8a.833.833 0 1 1-1.666 0h-1a.836.836 0 0 1-.833.834.834.834 0 0 1-.833-.834h-1a.836.836 0 0 1-.834.834A.835.835 0 0 1 1 3.907v-.925l.945-1.81A.33.33 0 0 1 2.235 1h7.196a.33.33 0 0 1 .288.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.926 5.016v6.15a.5.5 0 0 0 1 0v-6.15a.5.5 0 0 0-1 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.092 8.704h5.333a.5.5 0 0 0 0-1H1.092a.5.5 0 0 0 0 1"
  }))));
};
export default SvgStorefront;